import { organizationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';
import { OrganizationModel } from '../domain';

export const useCreateOrganization = () =>
  useMutation<OrganizationModel, unknown, FormData>((data) =>
    organizationsRepo.createOrganization(data),
  );
